import { ChangeDetectorRef, Component, ElementRef, HostListener, Injector, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { RegistrationService } from '@app/registration/registration.service';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { CommonModule } from '@angular/common';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DxButtonModule, DxDataGridModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { map, startWith, take, takeUntil } from 'rxjs';
import { HttpService } from '@core/services/http.service';
import { forkJoin } from 'rxjs';
import { CommonService } from '@app/shared/services/common.service';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { modalButtonTitles, ModalConfig, modalContent, modalHeading, toastMessage } from '@app/shared/constants/modal.model';
import { STATE_LIST } from '@app/shared/constants/state.constants';
import { AlertService } from '@app/@core/services/alert.service';
import { AuthService } from '@pics-core/dynamic';
import { ComplaintFormService } from '../complaint-form.service';
import { LoaderService } from '@app/@core/services/loader.service';
import { patternMatch } from '@app/shared/constants/validators.model';
import { DateMaskDirective } from '@app/shared/directives/dateMask.directive';
import { COMPLAINT_SECTIONS, COMPLAINT_SOURCE } from '@app/shared/constants/queue.constants';
import { ROLE_ID } from '@app/shared/constants/rolesConstant.model';
import { LocalService } from '@app/@core/services/local.service';
import { DataStoreService } from '@pics-core/dynamic';
import { ActivatedRoute, Router } from '@angular/router';
import { FingerprintPortalService } from '@app/fingerprint-portal/fingerprint-portal.service';
import { LOOKUP_USER_RETURN_URL_KEY } from '@app/shared/services/application-open-from-grid.service';

@Component({
  selector: 'app-complaint-review',
  templateUrl: './complaint-review.component.html',
  styleUrls: ['./complaint-review.component.scss'],
  standalone: true,
  imports: [
      CommonModule,
      DataGridComponent,
      DxDataGridModule,
      DxPopupModule,
      DxTemplateModule,
      DxButtonModule,
      MatTooltipModule,
      ReactiveFormsModule,
      FormsModule,
      CalendarModule,
      CheckboxModule,
      EditorModule,
      InputMaskModule,
      InputTextModule,
      RadioButtonModule,
      DropdownModule,
      DialogModule,
      DateMaskDirective
    ]
})
export class ComplaintReviewComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  showEditWitnessModal: boolean = false;
  @ViewChild('editWitnessModal', { static: false }) editWitnessModal!: TemplateRef<any>;
  @ViewChild('fileInputRef') fileInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('NotesModal') NotesModal!: TemplateRef<any>;
  @ViewChild('complaintEditor', { read: ElementRef }) complaintEditorEl?: ElementRef;
  toastMessage: any = {};
  witnessesForm: FormGroup;
  editWitnessesForm: FormGroup;
  licenseEducatorForm: FormGroup;
  complaintDecisionForm: FormGroup;
  complaintArchivalForm: FormGroup;
  complaintNotesForm:FormGroup;
  complaintForm: FormGroup;
  editComplaintNotesForm: FormGroup;
  details: boolean = true;
  Witnesses: boolean = true;
  Complainants: boolean = true;
  decision: boolean = true;
  archival: boolean = true;
  Notes: boolean = true;
  stateList = STATE_LIST;
  isMobile = false;
  resizeObservable$: Subscription | undefined;
  @ViewChild('employeeGrid') employeeGrid?: DataGridComponent;
  text: string | undefined;
  editWitnessIndex: number | undefined;
  selectedRow: any = null;
  witnessesDataGridConfig: DataGridVO = DataGridVO.create({});
  supportingWitnessesDataGrid: DataGridVO = DataGridVO.create({});
  licenseEducatorDataGridConfig: DataGridVO = DataGridVO.create({});
  searchLicenseEducatorDataGridConfig: DataGridVO = DataGridVO.create({});
  complaintNotesGridConfig: DataGridVO = DataGridVO.create({});
  customModal: NgbModalRef;
  createdDateFilterOptions: string[] = [];
  createdDateFilterDates: { [year: string]: string[] } = {};
  applicationData: any;
  applicationData2: any;
  applicationStatus: any[] = [];
  filteredwitnessesData: any[] = [];
  filteredsupportingWitnessesData: any[] = [];
  licenseEducatorData: any[] = [];
  searchLicenseEducatorData: any[] = [];
  complaintNotesData: any[] = [];
  applicationtypes: any[] = [];
  uploadedFiles: any[] = [];
  witnessesHeaders: any[] = [];
  supportingWitnessesHeaders: any[] = [];
  licenseEducatorHeaders: any[] = [];
  complaintNotesHeaders: any[] = [];
  visibleColumns: { [key: string]: boolean } = {};
  visibleSupportingColumns: { [key: string]: boolean } = {};
  visibleLicenseEducatorColumns: { [key: string]: boolean } = {};
  visibleComplaintNotesColumns: { [key: string]: boolean } = {};
  visibleSearchLicenseEducatorColumns: { [key: string]: boolean } = {};
  allColumns: any[] = [];
  allSupportingColumns: any[] = [];
  licenseEducatorColumns: any[] = [];
  complaintNotesColumns: any[] = [];
  showColumnChooser = false;
  showSupportingColumnChooser = false;
  showLicenseEducatorColumnChooser = false;
  showSearchLicenseEducatorColumnChooser = false;
  showDownloadDialog = false;
  rowDownloadDialogIndex: number | null = null;
  readonly disableAppIdColumn = 'application_id';
  appIdFilterOptions: string[] = [];
  appIdFilterSelected: string[] = [];
  appTypeFilterOptions: string[] = [];
  appTypeFilterSelected: string[] = [];
  appTypeFilterAllSelected = false;
  selectedApplicationId: string | null = null;
  showDeleteModal: boolean = false;
  showDeleteNotesModal: boolean = false;
  witnessDeleteIndex: number | null = null;
  showDraftModal: boolean = false;
  draftApplication: any = null;
  uploadError: string | null = null;
  lookupMessages: any;
  lookupToast: any;
  lookupGeneric: any;
  lookupPlaceholder: any;
  searchStates = {
    application_id: false,
    application_type: false,
    created_date: false,
    submitted_date: false,
    application_status: false
  };
  previousUrl: any;
  supportingDocDeleteIndex: number | null = null;
  isSupportingDelete: boolean = false;
  chiefInvestigator: boolean = false;
  showCreatedDateFilterDialog = false;
  showSubmittedDateFilterDialog = false;
  isLoading: boolean = false;
  showToast: boolean = false;
  toastTimer: any;
  saveText: string = 'Update';
  errorMessages: any[] = [];
  errorMessage: any = {};
  genericMessage: any = {};
  original$!: Observable<any>;
  editWitnessOriginalValue: any;  
  isChanged: boolean = false;
  phoneExists: boolean = false;
  phoneError: boolean = false;
  isPhoneFocused: boolean = false;
  toastMessages: any[] = [];
  genericMessages: any[] = [];
  placeholderMessages: any[] = [];
  placeholderMessage: any = {};
  complaintStatusMessages: any[] = [];
  complaintNotesSectionList = COMPLAINT_SECTIONS;
  complaintArchivalStatusMessages: any[] = [];
  oneFileIsRequired: boolean;
  oneFileIsRequiredError: string;
  categoryError: string;
  docTypeError: string;
  filteredDocumentTypes: any[] = [];
  categories: any[] = [];
  @Input()
  id: number | null = null;
  viewOnly: boolean = false;
  uploadData: any = {
    file: null,
    category: '',
    docType: ''
  };
  selectedFile: File | null = null;
  saveEnable: boolean = true;
  @ViewChild('dateTextInput') dateTextInput?: ElementRef<HTMLInputElement>;
  @ViewChild('startHiddenDateInput') startHiddenDateInput?: ElementRef<HTMLInputElement>;
  todayString:string;
  typeParam:string|null = null;
  licenseDeleteIndex: number | null = null;
  stripHtml = (html: string): string => {
      if (!html) return '';
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    }; 


    complaintSource :any;
    assignToList: any[] = [];
    user: any | null = null;
    complaintId : any | null = null;
    complaintFormId: any | null = null;
    showComplaintStatus: boolean = false;
    showAssignedToField: boolean = false;
    isViewNotes: boolean = false;
    isEditNotes: boolean = false;
    selectedNotesRow: any = null;
    deleteSelectedNotesRow: any = null;
      injector: Injector;
      dataStore: DataStoreService;
  constructor(
    private readonly fb: FormBuilder,
    private ngbService: NgbModal,
    private readonly registrationService: RegistrationService,
    private httpService: HttpService,
    private cd: ChangeDetectorRef,
    private elRef: ElementRef,
    private commonService: CommonService,
    private modalService: NgbModal,
    private readonly alertService: AlertService,
    private authServices: AuthService,
    private complaintFormService: ComplaintFormService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
    private sessionStorage: LocalService,
     public router: Router,
        injector: Injector,
         private route: ActivatedRoute,
    private fingerprintService : FingerprintPortalService     
  ) {
    this.selectedFile = null;
    this.applicationtypes = [];
    this.uploadedFiles = [];
    this.applicationData2 = [];
    this.applicationtypes = [];
    this.applicationStatus = [];
    this.filteredwitnessesData = [];
    this.filteredsupportingWitnessesData = [];
    this.licenseEducatorData = [];
    this.appIdFilterOptions = [];
    this.appIdFilterSelected = [];
    this.appTypeFilterOptions = [];
    this.appTypeFilterSelected = [];
     this.injector = injector;
        this.dataStore = injector.get<DataStoreService>(DataStoreService);
  }


  ngOnInit(): void {
    this.typeParam = this.sessionStorage.getItem('complaintFlowType');
    const complaintMode = this.sessionStorage.getItem('complaintMode');
    this.viewOnly = (complaintMode === "view") ? true : false;
    this.user = JSON.parse(window.sessionStorage.getItem('user'));
    if(this.user.userroles[0].id === ROLE_ID.Chief_Compliance_Investigator){
        this.chiefInvestigator = true;
      }
    this.loadDropdownDataMessages();
    this.complaintForm = this.fb.group({
      dateOfComplaint: [null, [Validators.pattern(patternMatch.date)]],
      educatorsFirstName: [null,
        [Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)]],
      complaintTextData: ['', Validators.required],
      complainantFirstName: [null,
        [Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)]],
      complainantLastName: [null,
        [Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)]
      ],
      complainantEmail: [null,Validators.pattern(patternMatch.registrationEmail)],
      complainantPhoneNumber: [null,
        [
        Validators.pattern('^(\\+1[ ]?)?\\(\\d{3}\\)[ ]?\\d{3}-\\d{4}$'),
        Validators.maxLength(17)]],
      complainantStreetAddress: [null, [
      Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s.,\\-'/#]*$"),
      Validators.minLength(3),
      Validators.maxLength(60)]],
      complainantCity: [null,
        [
          Validators.pattern("^[A-Za-z\\s'-]{2,60}$"),
          Validators.minLength(2),
          Validators.maxLength(60)
        ]
      ],
      complainantState: [null],
      complainantZip: [null,
        [Validators.pattern('^\\d{5}(|-\\d{4})$'),  // Either 5 digits or 5 digits followed by hyphen and 4 digits
        Validators.minLength(5),
        Validators.maxLength(10)]],
    });
    this.witnessesForm = this.fb.group({
      witnessesName: [null, [Validators.required,
      Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
      Validators.minLength(2),
      Validators.maxLength(30)
      ]],
      witnessesEmail: [null, [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,10}$/)]],
      witnessesPhone: [null,
        [
          Validators.pattern('^(\\+1[ ]?)?\\(\\d{3}\\)[ ]?\\d{3}-\\d{4}$'),
          Validators.maxLength(17)
        ]
      ],
      witnessesAddress: [null,
        [
          Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s.,\\-'/#]*$"),
          Validators.minLength(3),
          Validators.maxLength(60)
        ]
      ],
      witnessesCity: [null, [Validators.pattern("^[A-Za-z\\s'-]{2,60}$"), Validators.minLength(2), Validators.maxLength(60)]],
      witnessesState: [null],
      witnessesZip: [null, [
        Validators.pattern("^\\d{5}(|-\\d{4})$"),  // Either 5 digits or 5 digits followed by hyphen and 4 digits
        Validators.minLength(5),
        Validators.maxLength(10)
      ]],
      witnessesTextData: [null]
    });
    this.editWitnessesForm = this.fb.group({
      witnesseName: [null,
        [Validators.required,
        Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)]
      ],
      witnessesEmail: [null, [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,10}$/)]],
      witnessesPhone: [null,
        [
          Validators.pattern('^(\\+1[ ]?)?\\(\\d{3}\\)[ ]?\\d{3}-\\d{4}$'),
          Validators.maxLength(17)]
      ],
      witnessesAddress: [null,
        [
          Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s.,\\-'/#]*$"),
          Validators.minLength(3),
          Validators.maxLength(60)]
      ],
      witnessesCity: [null, [Validators.pattern("^[A-Za-z\\s'-]{2,60}$"), Validators.minLength(2), Validators.maxLength(60)]],
      witnessesState: [null],
      witnesseZip: [null, [
        Validators.pattern('^\\d{5}(|-\\d{4})$'),  // Either 5 digits or 5 digits followed by hyphen and 4 digits
        Validators.minLength(5),
        Validators.maxLength(10)
      ]],
    }, { validators: this.cityStateRequiredIfZipValid });
    this.licenseEducatorForm = this.fb.group({
      educator_name : [null],
      primary_email : [null],
      license_number : [null]
    });
    this.complaintDecisionForm = this.fb.group({
      complaintStatus : [null, Validators.required],
      complaintAssign : [null]
    });
    this.complaintArchivalForm = this.fb.group({
      complaintArchivalStatus : [ '1', Validators.required]
    });
    this.complaintNotesForm = this.fb.group({
      complaintNotesSection : [null, Validators.required],
      complaintNotesTextData : [null, [Validators.required,Validators.maxLength(4000)]]
    });
    this.editComplaintNotesForm = this.fb.group({
      editNotesSection : [null, Validators.required],
      editNotesTextData : [null, [Validators.required,Validators.maxLength(4000)]]
    });
    this.loadDashboardHeaders();
    // If component is set to view-only, disable interactive controls
    this.applyViewOnly();
    if(this.typeParam === 'add'){
      this.complaintId = JSON.parse(this.sessionStorage.getItem('complaintId'));
      this.complaintFormId = this.sessionStorage.getItem('complaintFormId');
      this.complaintForm.get('complainantEmail')?.setValue(this.user.email);
      this.complaintSource = COMPLAINT_SOURCE.INTERNAL;
      this.complaintForm.get('complainantFirstName')?.setValue(this.user.firstname);
      this.complaintForm.get('complainantLastName')?.setValue(this.user.lastname);
    }else{
      setTimeout(() => {
        const payload = { complaintId: this.typeParam };
      this.complaintFormService.fetchComplaintDetails(payload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          if(response && response.status === 'success'){
            this.complaintId = this.typeParam;
            const html = `<p>${response.data?.data?.strDescription}</p>`;
            this.complaintFormId = response.data?.data?.intComplaintFormId || null;
            this.complaintForm.get('dateOfComplaint')?.setValue(response.data?.data?.dtDateOfIncident || null);
            this.complaintForm.get('educatorsFirstName')?.setValue(response.data?.data?.strEducatorName || null);
            // this.complaintForm.get('complaintTextData')?.setValue(html,{ emitEvent: false });
            this.complaintForm.get('complainantFirstName')?.setValue(response.data?.data?.strComplaintFirstName || null);
            this.complaintForm.get('complainantLastName')?.setValue(response.data?.data?.strComplaintLastName || null);
            this.complaintForm.get('complainantEmail')?.setValue(response.data?.data?.strComplaintEmailAddress || null);
            this.complaintForm.get('complainantPhoneNumber')?.setValue(response.data?.data?.strComplaintMobileNumber || null);
            this.complaintForm.get('complainantStreetAddress')?.setValue(response.data?.data?.strComplaintStreetAddress || null);
            this.complaintForm.get('complainantCity')?.setValue(response.data?.data?.strCdCity || null);
            this.complaintForm.get('complainantState')?.setValue(response.data?.data?.strCdState || null);
            this.complaintForm.get('complainantZip')?.setValue(response.data?.data?.strZipcode || null);
            this.filteredwitnessesData.push(...(response.data?.data?.witnesses || []));
            this.filteredsupportingWitnessesData.push(...(response.data?.data?.documentUpload || []));
            this.licenseEducatorData.push(...(response.data?.data?.licenseEducator || []));
            this.complaintSource = response.data?.data?.strComplaintSource || '';
            this.complaintDecisionForm.get('complaintStatus')?.setValue(String(response.data?.data?.complaintStatus));
            this.complaintDecisionForm.get('complaintAssign')?.setValue(response.data?.data?.assignee || null);
            if(response.data?.data?.complaintArchivalStatus != null){
             this.complaintArchivalForm.get('complaintArchivalStatus')?.setValue(String(response.data?.data?.complaintArchivalStatus));
            }
            this.complaintNotesData.push(...(response.data?.data?.complaintNotes || []));
            this.setNotesData();
            this.displayshowComplaintStatus();
              this.complaintForm.get('complaintTextData')?.setValue(html, { emitEvent: false });
              try { this.cd.detectChanges(); } catch (e) { }
              setTimeout(() => {
                try { this.cd.detectChanges(); } catch (e) { }
                try {
                  const el = this.complaintEditorEl?.nativeElement as HTMLElement | undefined;
                  if (el) {
                    const ql = el.querySelector('.ql-editor') as HTMLElement | null;
                    if (ql) {
                      ql.innerHTML = html || '';
                    }
                  }
                } catch (e) { }
              }, 50);
               if(this.complaintSource === COMPLAINT_SOURCE.EXTERNAL){
                  this.complaintForm.get('complainantEmail')?.disable();
                }else{
                  this.complaintForm.get('complainantEmail')?.enable();
                }
          }
        },
      });
      }, 1000);
      
    }
    this.loadDropdownData();
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };

    this.witnessesForm.get('witnessesPhone')?.valueChanges.subscribe(() => {
      this.validateWitnessPhone();
    });
    this.witnessesForm.get('witnessesAddress')?.valueChanges.subscribe(() => {
      this.validateWitnessStreet();
    });
    this.witnessesForm.get('witnessesCity')?.valueChanges.subscribe(() => {
      this.validateWitnessCity();
    });
    this.witnessesForm.get('witnessesZip')?.valueChanges.subscribe(() => {
      this.formatWitnessZipCode({ target: { value: this.witnessesForm.get('witnessesZip')?.value || '' } });
    });
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    this.todayString = `${yyyy}-${mm}-${dd}`;
    this.complaintForm.get('dateOfComplaint')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
      next: (value: string) => {
        let error: string | null = null;
        if (value === '' || value == null) {
          this.clearDateInput();
          return;
        }
        if (new Date(value) > new Date()) {
          error = 'futureDate';
          this.complaintForm.get('dateOfComplaint')?.setErrors({ [error]: true });
        }
      },
    });
    this.assignList();

   this.editWitnessesForm.valueChanges.pipe(
      startWith(this.editWitnessesForm.value)
    ).subscribe(value => {
      this.isChanged = JSON.stringify(this.editWitnessOriginalValue) !== JSON.stringify(value);
    });
  }

  clearDateInput(){
    // clear visible text input
    if (this.dateTextInput?.nativeElement) {
      this.dateTextInput.nativeElement.value = '';
    }
    if(this.startHiddenDateInput?.nativeElement){
      this.startHiddenDateInput.nativeElement.value = '';
    }
  }
  onStartDateChange(event: any,dateTextInput: HTMLInputElement) {
    const dateValue = event.target.value;
    if (dateValue) {
      const d = new Date(dateValue);
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const yyyy = d.getFullYear();
      const formatted = `${mm}/${dd}/${yyyy}`;
      this.complaintForm.get('dateOfComplaint')?.setValue(formatted);
      return;
    }
  }

 onSubmit(): void {
    const form = this.complaintForm.getRawValue();
    console.log('Form Data:', form);
    const stripHtml = (html: string): string => {
      if (!html) return '';
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    };

    // Encrypt helper
    const encrypt = (val: string) => val ? this.commonService.encrypt(val) : null;

    const payload = {
      strComplaintFirstName: encrypt(this.complaintForm.get('complainantFirstName')?.value),
      strComplaintLastName: encrypt(this.complaintForm.get('complainantLastName')?.value),
      strComplaintEmailAddress: encrypt(this.complaintForm.get('complainantEmail')?.value),
      strComplaintMobileNumber: encrypt(this.complaintForm.get('complainantPhoneNumber')?.value),
      strComplaintStreetAddress: encrypt(this.complaintForm.get('complainantStreetAddress')?.value),
      strCdCity: encrypt(this.complaintForm.get('complainantCity')?.value),
      strCdState: encrypt(this.complaintForm.get('complainantState')?.value),
      strZipcode: encrypt(this.complaintForm.get('complainantZip')?.value),
      strEducatorName: encrypt(this.complaintForm.get('educatorsFirstName')?.value),
      intCreatedBy: this.user.id,
      dtCreatedDate: new Date().toISOString(),
      intUpdatedBy: this.user.id,
      dtUpdatedDate: new Date().toISOString(),
      dtDateOfIncident: encrypt(this.complaintForm.get('dateOfComplaint')?.value),
      strDescription: encrypt(stripHtml(this.complaintForm.get('complaintTextData')?.value)),
      strOldId: 'abc123',
      strComplaintSource: COMPLAINT_SOURCE.INTERNAL,
      witnesses: this.filteredwitnessesData.map(w => {
        const descStripped = stripHtml(this.getWitnessDescription(w));
        return {
          strWitnessName: encrypt(w.strWitnessName || w.witnessesName),
          strWitnessEmailAddress: encrypt(w.strWitnessEmailAddress || w.witnessesEmail),
          strWitnessMobileNumber: encrypt(w.strWitnessPhoneNumber || w.witnessesPhone),
          strWitnessStreetAddress: encrypt(w.strStreetAddress || w.witnessesAddress),
          strCdCity: encrypt(w.strCity || w.witnessesCity),
          strCdState: encrypt(w.strState || w.witnessesState),
          strZipcode: encrypt(w.strZip || w.witnessesZip),
          strWitnessDescription: encrypt(descStripped),
          isWitnessActive: w.isWitnessActive !== undefined ? w.isWitnessActive : true,
          strWitnessCreatedBy: w.strWitnessCreatedBy,
          witnessOldId: w.witnessOldId || ''
        }
      }),
      documentUpload: this.filteredsupportingWitnessesData.map(doc => {
        return {
          strFileName: encrypt(doc.strFileName),
          strFileHash: doc.strFileHash,
          strDocumentType: doc.strDocumentType,
          strStatus: doc.strStatus,
          strCdDocumentCategory: doc.strCdDocumentCategory,
        }
      }),
      isEmailVerified: window.sessionStorage.getItem('isEmailVerified') === 'true',
      attachments: this.uploadedFiles,
      licensedEducators : this.licenseEducatorData.map(lic => {
        return {
          strEducatorName : lic.educator_name,
          strComplaintEmailAddress : lic.primary_email,
          strLicenseNumber : lic.license_number
        }
      }),
      strAssignee : this.user.id,
      strComplaintId: this.complaintId,
      intComplaintFormId: this.complaintFormId
    };
    console.log(payload)
    this.complaintFormService.internalSubmit(payload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if(response.data?.success){
          this.alertService.success(this.toastMessage['T0054']);
          this.sessionStorage.setItem('complaintFlowType', this.complaintId);
           const assigned = this.complaintStatusMessages.find(s => s.value === 'Assigned');
          this.complaintDecisionForm.get('complaintStatus')?.setValue(assigned.key);
          this.complaintDecisionForm.get('complaintAssign')?.setValue(this.user.id);
          this.complaintArchivalForm.get('complaintArchivalStatus')?.setValue(this.complaintArchivalStatusMessages.find(s => s.value === 'Active')?.key);
          this.displayshowComplaintStatus();
        }else{
          this.alertService.error('Error submitting complaint. Please try again later.');
        }
      },
      error: (error) => {
        console.error('Error submitting complaint', error);
      }
    });
  } 
  
  getWitnessDescription(witness: any): string {
    return witness.strWitnessDescription || witness.strWitnessTextData || '';
  }
  disabledUpdateComplaint(): boolean {
    return this.complaintForm.invalid || this.licenseEducatorData.length === 0;
  }
  addData() {
    const formValue = this.witnessesForm.getRawValue();
    const newWitness = {
      strWitnessName: formValue.witnessesName,
      strWitnessEmailAddress: formValue.witnessesEmail,
      strWitnessPhoneNumber: formValue.witnessesPhone,
      strStreetAddress: formValue.witnessesAddress,
      strCity: formValue.witnessesCity,
      strState: formValue.witnessesState,
      strZip: formValue.witnessesZip,
      strWitnessTextData: this.stripHtml(formValue.witnessesTextData || ''),
      intWitnessSupportingDocumentsId: null,
    };
     if(this.typeParam !== 'add'){
      const paylaod = {
        ...newWitness,
        complaintId: this.complaintId,
        complaintFormId: this.complaintFormId,
        intCreatedBy: this.user.id
      };
      this.complaintFormService.insertWitnessDocument(paylaod).pipe(take(1), takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          newWitness.intWitnessSupportingDocumentsId = response.data.data[0].witness_supporting_documents_id;
        },
        error: (error) => {
          console.error('Error inserting witness document:', error);
        }
      });
    }
    setTimeout(() => {
      this.witnessaddedData(newWitness);
    }, 1000);
  }
  witnessaddedData(witness: any) {
     this.filteredwitnessesData = [...this.filteredwitnessesData, witness];
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredwitnessesData
    });
    this.alertService.success(this.toastMessage['T0005']);
    this.witnessesForm.reset();
    if (this.cd && typeof this.cd.detectChanges === 'function') {
      this.cd.detectChanges();
    }
  }
  resetData() {
    this.witnessesForm.reset();
  }

  onColumnVisibilityChange(columnField: string, isVisible: boolean) {
    this.visibleColumns[columnField] = isVisible;
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredwitnessesData
    });
  }
  onSupportingColumnVisibilityChange(columnField: string, isVisible: boolean) {
    this.visibleSupportingColumns[columnField] = isVisible;
    this.supportingWitnessesDataGrid = DataGridVO.create({
      customHeaders: this.supportingWitnessesHeaders,
      visibleColumns: this.visibleSupportingColumns,
      data: this.filteredsupportingWitnessesData
    });
  }
  onLicenseEducatorColumnVisibilityChange(columnField: string, isVisible: boolean) {
    this.visibleLicenseEducatorColumns[columnField] = isVisible;
    this.licenseEducatorDataGridConfig = DataGridVO.create({
      customHeaders: this.licenseEducatorHeaders,
      visibleColumns: this.visibleLicenseEducatorColumns,
      data: this.licenseEducatorData
    });
  }
  onSearchLicenseEducatorColumnVisibilityChange(columnField: string, isVisible: boolean) {
    this.visibleSearchLicenseEducatorColumns[columnField] = isVisible;
    this.searchLicenseEducatorDataGridConfig = DataGridVO.create({
      customHeaders: this.licenseEducatorHeaders,
      visibleColumns: this.visibleSearchLicenseEducatorColumns,
      data: this.searchLicenseEducatorData
    });
  }
  onLicenseEducator(){
    this.licenseEducatorForm.reset();
  }
  onRefresh(){
    this.licenseEducatorForm.reset();
    this.licenseEducatorHeaders.forEach(header => {
      this.visibleSearchLicenseEducatorColumns[header.dataField] = true;
    });
    this.searchLicenseEducatorData = [];
    this.searchLicenseEducatorDataGridConfig = DataGridVO.create({
      customHeaders: this.licenseEducatorHeaders,
      visibleColumns: this.visibleSearchLicenseEducatorColumns,
      data: this.searchLicenseEducatorData
    });
  }
  searchLicenseEducator(){
    let payload = {
      educator_name: this.licenseEducatorForm.get('educator_name')?.value || null,
      primary_email: this.licenseEducatorForm.get('primary_email')?.value || null,
      license_number: this.licenseEducatorForm.get('license_number')?.value || null
    };
    console.log('Searching with payload:', payload);
    this.complaintFormService.searchLicensedEducator(payload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        console.log('Search results:', response);
        let results = response.data.data || [];
         results = results.map((item: any) => {
          const first = (item.first_name || '').trim();
          const last = (item.last_name || '').trim();
          let name = [first, last].filter(Boolean).join(' ');
          if (!name && item.educator_name) {
            const parts = item.educator_name.trim().split(/\s+/);
            name = parts.length >= 3 ? `${parts[0]} ${parts[parts.length - 1]}` : item.educator_name.trim();
          }
          return { ...item, educator_name: name };
        });
        if (this.licenseEducatorData && this.licenseEducatorData.length>0) {
          results = results.filter((item: any) => this.getLicenseEducatorRowIndex(item) === -1);
        }
        if(results.length === 0){
          this.alertService.error(this.toastMessage['T0055']);
        }
        this.searchLicenseEducatorData = results;
        this.searchLicenseEducatorDataGridConfig = DataGridVO.create({
          customHeaders: this.licenseEducatorHeaders,
          visibleColumns: this.visibleSearchLicenseEducatorColumns,
          data: this.searchLicenseEducatorData
        });
      },
      error: (error) => {
        console.error('Error searching license educator', error);
      }
    });    
  }

  
  isSearchDisabled(): boolean {
    const form = this.licenseEducatorForm.value;

    const hasAnyValue =
      (form.educator_name && form.educator_name.trim() !== '') ||
      (form.primary_email && form.primary_email.trim() !== '') ||
      (form.license_number && form.license_number.trim() !== '');

    return !hasAnyValue;
  }


  onEditWitnessesReset(row: any) {
    this.selectedRow = { ...row };
    this.editWitnessesForm.patchValue({
      witnesseName: row.strWitnessName,
      witnessesEmail: row.strWitnessEmailAddress,
      witnessesPhone: row.strWitnessPhoneNumber,
      witnessesAddress: row.strStreetAddress,
      witnessesCity: row.strCity,
      witnessesState: row.strState,
      witnesseZip: row.strZip,
      witnessesTextData: row.strWitnessTextData
    });
    this.editWitnessesForm.markAsPristine();
  }

  openEditWitnessModal(row: any, index: number) {
    console.log('openEditWitnessModal called with index:', index, 'row:', row);
    this.selectedRow = { ...row };
    this.editWitnessIndex = index;
    // Find the matching state from stateList (case-insensitive)
    let matchedState = '';
    if (row.strState) {
      const found = this.stateList.find(
        (state: string) => state.toLowerCase() === row.strState.toLowerCase()
      );
      matchedState = found || '';
    }
    this.editWitnessesForm.patchValue({
      witnesseName: row.strWitnessName,
      witnessesEmail: row.strWitnessEmailAddress,
      witnessesPhone: row.strWitnessPhoneNumber,
      witnessesAddress: row.strStreetAddress,
      witnessesCity: row.strCity,
      witnessesState: matchedState || null,
      witnesseZip: row.strZip,
      witnessesTextData: row.strWitnessTextData
    });
    this.editWitnessOriginalValue = this.editWitnessesForm.value;
    // this.editWitnessesForm.markAsPristine();

    // this.original$ = of(this.editWitnessesForm.getRawValue());

    // this.isChanged$ = combineLatest([
    //   this.editWitnessesForm.valueChanges.pipe(startWith(this.editWitnessesForm.value)),
    //   this.original$
    // ]).pipe(
    //   map(([current, original]) => JSON.stringify(current) !== JSON.stringify(original))
    // );
    this.showEditWitnessModal = true;
    // Reset the destroy$ subject so subscription can be re-established
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'xl',
      windowClass: 'custom-edit-record-modal'
    };
    this.customModal = this.ngbService.open(this.editWitnessModal, options);
  }

  showLicenseEducatorModal(content: TemplateRef<any>) {
    this.onRefresh();
    this.modalService.open(content, { size: 'lg', centered: true, windowClass: 'custom-edit-record-modal' });
  }

  closeModal() {
    this.selectedRow = null;
    this.editWitnessesForm.reset();
    this.editWitnessesForm.markAsPristine();
    this.editWitnessesForm.markAsUntouched();
    this.showEditWitnessModal = false;
    this.customModal.close();
    this.customModal = null;
  }
  closeLicenseModal(){
    this.onRefresh();
    // this.licenseEducatorForm.reset();
    this.modalService.dismissAll();
  }

  // app dashboard
  loadDashboardHeaders() {
    this.commonService
      .getComplaintTabs()
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (headers: any) => {
          console.log('Loaded column metadata:', headers);
          this.witnessesHeaders = headers.witnessHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.witnessesHeaders.push({"dataField":"strWitnessTextData","caption":"Additional Information","label":"Additional Information","allowFiltering":true,"allowSearch":{"isSearchEnable":true , "type":"string"}});
          this.supportingWitnessesHeaders = headers.supportingHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.licenseEducatorHeaders = headers.licenseEducatorHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.complaintNotesHeaders = headers.complaintNotesHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.visibleColumns = {};
          this.visibleSupportingColumns = {};
          this.witnessesHeaders.forEach(header => {
            this.visibleColumns[header.dataField] = true;
          });
          this.supportingWitnessesHeaders.forEach(header => {
            this.visibleSupportingColumns[header.dataField] = true;
          });
          this.licenseEducatorHeaders.forEach(header => {
            this.visibleLicenseEducatorColumns[header.dataField] = true;
            this.visibleSearchLicenseEducatorColumns[header.dataField] = true;
          });
          this.complaintNotesHeaders.forEach(header => {
            this.visibleComplaintNotesColumns[header.dataField] = true;
          });
          this.allColumns = this.witnessesHeaders;
          this.allSupportingColumns = this.supportingWitnessesHeaders;
          this.licenseEducatorColumns = this.licenseEducatorHeaders;
          this.complaintNotesColumns = this.complaintNotesHeaders;
          this.isLoading = true;
          this.checkDeviceAndRedirect();
        },
        error: (error: any) => {
          console.error('Error loading column metadata:', error);
        }
      });
  }


  private async loadDropdownDataMessages() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=PLACEHOLDER MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=COMPLAINT_STATUS'),
      this.httpService.get('/domain/lookup?requestType=COMPLAINT_ARCHIVAL_STATUS')
    ]).subscribe({
      next: (item: any) => {
        this.errorMessages = item[0].data;
        this.toastMessages = item[1].data;
        this.genericMessages = item[2].data;
        this.placeholderMessages = item[3].data;
        this.complaintStatusMessages = item[4].data;
        this.complaintArchivalStatusMessages = item[5].data;
        // Process generic messages to make them easily accessible by key
        this.errorMessage = {};
        this.errorMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.errorMessage[message.key] = message.value;
          }
        });
        this.toastMessage = {};
        this.toastMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.toastMessage[message.key] = message.value;
          }
        });
        this.genericMessage = {};
        this.genericMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.genericMessage[message.key] = message.value;
          }
        });
        this.placeholderMessage = {};
        this.placeholderMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.placeholderMessage[message.key] = message.value;
          }
        });
        this.cd.detectChanges();

      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
  }

  private async loadDropdownData() {
    this.applicationData = [];
    this.applicationData2 = [];
    this.filteredwitnessesData = this.applicationData;
    this.filteredsupportingWitnessesData = this.applicationData2;
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredwitnessesData
    });
    this.supportingWitnessesDataGrid = DataGridVO.create({
      customHeaders: this.supportingWitnessesHeaders,
      visibleColumns: this.visibleSupportingColumns,
      data: this.filteredsupportingWitnessesData
    });
    this.licenseEducatorDataGridConfig = DataGridVO.create({
      customHeaders: this.licenseEducatorHeaders,
      visibleColumns: this.visibleLicenseEducatorColumns,
      data: this.licenseEducatorData
    });
    this.searchLicenseEducatorDataGridConfig = DataGridVO.create({
      customHeaders: this.licenseEducatorHeaders,
      visibleColumns: this.visibleSearchLicenseEducatorColumns,
      data: this.searchLicenseEducatorData
    });
    this.complaintNotesGridConfig = DataGridVO.create({
      customHeaders: this.complaintNotesHeaders,
      visibleColumns: this.visibleComplaintNotesColumns,
      data: this.complaintNotesData,
      showActionsColumn: (this.complaintNotesData?.length ?? 0) > 0
    });
    this.appIdFilterOptions = Array.from(new Set(this.applicationData.map(app => app.application_id)));
    this.appTypeFilterOptions = Array.from(
      new Set(this.applicationData.map(app => this.getApplicationTypeDisplayValue(app.application_type)))
    );
  }

  onDropFile(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const fileList = event.dataTransfer.files;
      const syntheticEvent = {
        target: {
          files: fileList
        }
      } as any;
      this.handleFileUpload(syntheticEvent);
    }
  }
  getApplicationTypeDisplayValue(key: string): string {
    if (!this.applicationtypes || !key) {
      return key || '';
    }

    const appType = this.applicationtypes.find(type => type.key === key);
    return appType ? appType.value : key;
  }

  closeColumnChooser() {
    this.showColumnChooser = false;
    this.showSupportingColumnChooser = false;
  }
  closeLicenseEducatorColumnChooser() {
    this.showLicenseEducatorColumnChooser = false;
  }
  closeSearchLicenseEducatorColumnChooser() {
    this.showSearchLicenseEducatorColumnChooser = false;
  }

  toggleDownloadDialog() {
    this.showDownloadDialog = !this.showDownloadDialog;
  }

  closeDownloadDialog() {
    this.showDownloadDialog = false;
  }

  openRowDownloadDialog(index: number) {
    if (this.rowDownloadDialogIndex === index) {
      this.rowDownloadDialogIndex = null;
    } else {
      this.rowDownloadDialogIndex = index;
    }
  }
  private async checkDeviceAndRedirect(): Promise<void> {
    this.isLoading = false;
    this.loadDropdownData();
  }
  closeRowDownloadDialog() {
    this.rowDownloadDialogIndex = null;
  }

  openDeleteModal(): void {
    this.showDeleteModal = true;
  }

  confirmDeleteWitnessRow() {
    if (this.isSupportingDelete && this.supportingDocDeleteIndex !== null) {
      const fileItem = this.filteredsupportingWitnessesData && this.filteredsupportingWitnessesData[this.supportingDocDeleteIndex];
      const url = fileItem.strFileHash;
      const contentType = fileItem.strDocumentType;
      if(this.typeParam !== 'add'){
      const Payload = {
        complaintId: this.complaintId,
        complaintDocumentId: this.filteredsupportingWitnessesData[this.supportingDocDeleteIndex].intComplaintDocumentId
      };
      this.complaintFormService.deleteSupportingDocument(Payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          console.log('Deleted Complaint Document:', response);
        },
        error: (error) => {
          console.error('Error deleting complaint document:', error);
        }
      });
    }
      this.httpService.deleteFile(url, contentType).subscribe({
        next: (response) => {
          this.handleSupportingWitnessDelete();
        },
        error: (error) => {
          console.error('Error deleting file:', error);
        }
      });

    }
    if (this.witnessDeleteIndex !== null && this.filteredwitnessesData[this.witnessDeleteIndex]) {
      this.handleWitnessDelete();
    }
    if(this.licenseDeleteIndex !== null){
      if(this.typeParam !== 'add'){
        const deletedLicenseEducator = this.licenseEducatorData[this.licenseDeleteIndex];
        const payload = {
          complaintCaseEducatorId: deletedLicenseEducator.intComplaintCaseEducatorId,
          complaintId: this.complaintId
        };
        this.complaintFormService.deleteComplaintEducator(payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
          next: (response) => {
            console.log('Deleted Complaint Educator:', response);
          },
          error: (error) => {
            console.error('Error deleting complaint educator:', error);
          }
        });
      }
      this.licenseEducatorData.splice(this.licenseDeleteIndex, 1);
      this.licenseEducatorData = [...this.licenseEducatorData];
      this.licenseEducatorDataGridConfig = DataGridVO.create({
        customHeaders: [...this.licenseEducatorHeaders],
        visibleColumns: { ...this.visibleLicenseEducatorColumns },
        data: this.licenseEducatorData
      });
      this.alertService.success(this.toastMessage['T0040']);
    }
    if(this.deleteSelectedNotesRow){
      this.confirmDeleteNotesRow(this.deleteSelectedNotesRow);
    }
    this.resetDeleteState();
  }

  private handleSupportingWitnessDelete() {
    const deletedFile = this.filteredsupportingWitnessesData[this.supportingDocDeleteIndex!];
    this.filteredsupportingWitnessesData.splice(this.supportingDocDeleteIndex!, 1);
    this.filteredsupportingWitnessesData = [...this.filteredsupportingWitnessesData];
    if (this.uploadedFiles.length === 1 && this.uploadedFiles[0]?.file === deletedFile?.file) {
      this.uploadedFiles = [];
    }
    this.supportingWitnessesDataGrid = DataGridVO.create({
      customHeaders: [...this.supportingWitnessesHeaders],
      visibleColumns: { ...this.visibleSupportingColumns },
      data: this.filteredsupportingWitnessesData,
      _changeKey: Date.now() + Math.random()
    });
    this.alertService.success(this.toastMessage['T0042']);
    if (this.cdr && typeof this.cdr.detectChanges === 'function') {
      this.cdr.detectChanges();
    }
    this.isSupportingDelete = false;
    this.supportingDocDeleteIndex = null;
    this.showDeleteModal = false;
  }

  private handleWitnessDelete() {
    if(this.typeParam !== 'add'){
      const Payload = {
        complaintId: this.complaintId,
        intWitnessSupportingDocumentsId: this.filteredwitnessesData[this.witnessDeleteIndex].intWitnessSupportingDocumentsId
      }
      this.complaintFormService.deleteWitnessDocument(Payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          console.log('Deleted Witness Document:', response);
        },
        error: (error) => {
          console.error('Error deleting witness document:', error);
        }
      });
    }
    this.filteredwitnessesData.splice(this.witnessDeleteIndex!, 1);
    this.filteredwitnessesData = [...this.filteredwitnessesData];
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: [...this.witnessesHeaders],
      visibleColumns: { ...this.visibleColumns },
      data: this.filteredwitnessesData,
      _changeKey: Date.now() + Math.random()
    });
    if (this.employeeGrid && this.employeeGrid.applicationData) {
      this.employeeGrid.applicationData = [];
    }
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: [...this.witnessesHeaders],
      visibleColumns: { ...this.visibleColumns },
      data: this.filteredwitnessesData.length ? this.filteredwitnessesData : [],
      _changeKey: Date.now() + Math.random()
    });
    if (this.filteredwitnessesData.length === 0 && this.employeeGrid && this.employeeGrid.applicationData) {
      this.employeeGrid.applicationData = [];
    }
    if (this.employeeGrid && this.employeeGrid.dataGrid && this.employeeGrid.dataGrid.instance) {
      this.employeeGrid.dataGrid.instance.refresh();
    }
    this.alertService.success(this.toastMessage['T0040']);
    if (this.cd && typeof this.cd.detectChanges === 'function') {
      this.cd.detectChanges();
    }
    this.witnessDeleteIndex = null;
  }

  private resetDeleteState() {
    this.isSupportingDelete = false;
    this.supportingDocDeleteIndex = null;
    this.showDeleteModal = false;
    this.showDeleteNotesModal = false;
    this.deleteSelectedNotesRow = null;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
    this.showDeleteNotesModal = false;
    this.witnessDeleteIndex = null;
    this.licenseDeleteIndex = null;
    this.selectedApplicationId = null;
    this.deleteSelectedNotesRow = null;
  }

  deleteWitnessRow(index: number) {
    this.witnessDeleteIndex = index;
    this.showDeleteModal = true;
  }


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    let clickedInside = false;
    const searchContainers = this.elRef.nativeElement.querySelectorAll('.search-container');
    searchContainers.forEach((container: HTMLElement) => {
      if (container.contains(event.target as Node)) {
        clickedInside = true;
      }
    });

    if (!clickedInside) {
      for (const key of Object.keys(this.searchStates)) {
        if (this.searchStates[key]) {
          this.searchStates[key] = false;
        }
      }
    }
  }

  setShortToastTimer() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    this.toastTimer = setTimeout(() => {
      this.showToast = false;
    }, 4000); // 4 seconds
  }


  checkPhone() {
    let cleanedPhoneNumber = this.complaintForm.get('phoneNumber')?.value.replace(/\D/g, '');
    let request = {
      phone: cleanedPhoneNumber
    };
    if (this.complaintForm.get('phoneNumber')?.value !== '') {
      this.registrationService.checkPhone(request).subscribe({
        next: response => {
          if (response.data.exists === true) {
            // this.closeConfirmModal();
            window.scrollTo(0, 0);
            this.phoneError = true;
            this.phoneExists = true;
            setTimeout(() => {
              this.phoneError = false;
            }, 5000);
          } else {
            this.phoneError = false;
            this.phoneExists = false;
          }
        }
      });
    }
  }

  formatPhoneNumber(event: any) {
    const inputEl = event.target;
    let value = inputEl.value;   
    const inputType = event.inputType; 
    // "deleteContentBackward", "insertText", etc.
    const isDeleting = inputType && inputType.includes('delete');
    //Allow deletion of +1 fully
    if (isDeleting) {
      this.complaintForm.get('complainantPhoneNumber')?.setValue(value, { emitEvent: false });
      return;
    }
    if (!value.startsWith('+1') && value !== '+') {
      value = '+1 ' + value.replace(/^\+/, '');
    }
    const formatted = this.formatPhoneNumberValue(value);
    inputEl.value = formatted;
    this.complaintForm.get('complainantPhoneNumber')?.setValue(formatted, { emitEvent: false });
  }
  formatWitnessPhoneNumber(event: any) {
    const inputEl = event.target;
    let value = inputEl.value;   
    const inputType = event.inputType; 
    // "deleteContentBackward", "insertText", etc.
    const isDeleting = inputType && inputType.includes('delete');
    //Allow deletion of +1 fully
    if (isDeleting) {
      this.witnessesForm.get('witnessesPhone')?.setValue(value, { emitEvent: false });
      return;
    }
    if (!value.startsWith('+1') && value !== '+') {
      value = '+1 ' + value.replace(/^\+/, '');
    }
    const formatted = this.formatPhoneNumberValue(value);
    inputEl.value = formatted;
    this.witnessesForm.get('witnessesPhone')?.setValue(formatted, { emitEvent: false });
  }
  formatEditWitnessPhoneNumber(event: any) {
    const inputEl = event.target;
    let value = inputEl.value;   
    const inputType = event.inputType; 
    // "deleteContentBackward", "insertText", etc.
    const isDeleting = inputType && inputType.includes('delete');
    //Allow deletion of +1 fully
    if (isDeleting) {
      this.editWitnessesForm.get('witnessesPhone')?.setValue(value, { emitEvent: false });
      return;
    }
    if (!value.startsWith('+1') && value !== '+') {
      value = '+1 ' + value.replace(/^\+/, '');
    }
    const formatted = this.formatPhoneNumberValue(value);
    inputEl.value = formatted;
    this.editWitnessesForm.get('witnessesPhone')?.setValue(formatted, { emitEvent: false });
  }

  cityStateRequiredIfZipValid(form: FormGroup) {
    const zip = form.get('complainantZip')?.value || '';
    const city = form.get('complainantCity')?.value || '';
    const state = form.get('complainantState')?.value || '';
    const zipPattern = /^\d{5}$|^\d{5}-\d{4}$/;

    // If zip is valid but city or state is missing, return error
    if (zipPattern.test(zip) && (!city || !state)) {
      return { cityStateMissing: true };
    }
    return null;
  }

  zipCodeFormat(event: any, controlName: string) {
    let value = event.target.value.replace(/[^0-9]/g, '');
    let formatted = value;
    let error: string | null = null;
    if (value.length > 9) value = value.substring(0, 9);
    if (value.length === 5) {
      formatted = value;
    } else if (value.length === 9) {
      formatted = value.substring(0, 5) + '-' + value.substring(5);
    } else if (value !== "") {
      error = 'M0023';
    }
    if (controlName === 'complainantZip') {
      this.complaintForm.get(controlName)?.setValue(formatted, { emitEvent: false });
      if (error) {
        this.complaintForm.get(controlName)?.setErrors({ [error]: true });
      } else {
        this.complaintForm.get(controlName)?.setErrors(null);
      }
    } else if(controlName === 'witnessesZip') {
      this.witnessesForm.get(controlName)?.setValue(formatted, { emitEvent: false });
      if (error) {
        this.witnessesForm.get(controlName)?.setErrors({ [error]: true });
      } else {
        this.witnessesForm.get(controlName)?.setErrors(null);
      }
    }
     else if(controlName === 'witnesseZip') {
      this.editWitnessesForm.get(controlName)?.setValue(formatted, { emitEvent: false });
      if (error) {
        this.editWitnessesForm.get(controlName)?.setErrors({ [error]: true });
      } else {
        this.editWitnessesForm.get(controlName)?.setErrors(null);
      }
    }

  }

  formatWitnessZipCode(event: any) {
    // Allow alphabets, numbers, spaces, and hyphens, max 10 chars
    let value = event.target.value.replace(/[^A-Za-z0-9\s-]/g, '');
    if (value.length > 10) value = value.substring(0, 10);
    this.witnessesForm.get('witnessesZip')?.setValue(value, { emitEvent: false });
    // Let validators handle errors
  }

  getWitnessRowIndex(row: any): number {
    return this.filteredwitnessesData.findIndex(r =>
      r.strWitnessName === row.strWitnessName &&
      r.strWitnessEmailAddress === row.strWitnessEmailAddress &&
      r.strWitnessPhoneNumber === row.strWitnessPhoneNumber
    );
  }
  getLicenseEducatorRowIndex(row: any): number {
    return this.licenseEducatorData.findIndex(r =>
      r.educator_name === row.educator_name &&
      r.license_number === row.license_number &&
      r.primary_email === row.primary_email
    );
  }
  
  onComplaintEditorInteraction(event:Event): void {
    const control = this.complaintForm.get('complaintTextData');
    try {
      console.log('onComplaintEditorInteraction called');
    } catch { }
    if (control && !control.touched) {
      control.markAsTouched();
    }
    const value = control?.value;
    const MAX_CHARS = 4000;
    if(value?.length >= MAX_CHARS){
      const truncated = value.slice(0, MAX_CHARS);

      // Update the form control (keeps things consistent)
      // NOTE: This replaces content with plain text (formatting lost).
      this.complaintForm.get('complaintTextData')?.setValue(truncated, { emitEvent: false });
    }
  }

  get formTouched(): boolean {
    return this.witnessesForm.dirty || Object.values(this.witnessesForm.controls).some(ctrl => ctrl.dirty);
  }
  get formTouchedd(): boolean {
    return this.editWitnessesForm.dirty || Object.values(this.editWitnessesForm.controls).some(ctrl => ctrl.dirty);
  }
  get notesFormTouched(): boolean {
    return this.complaintNotesForm.dirty || Object.values(this.complaintNotesForm.controls).some(ctrl => ctrl.dirty);
  }
  get formControls() {
    return this.complaintForm.controls;
  }

  showUploadModal(content: any) {
    this.alertService.clear();
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch { }
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
    this.oneFileIsRequired = false;
    this.categoryError = '';
    this.docTypeError = '';
    this.filteredDocumentTypes = [];
    this.autoSelectSingleCategory();

    this.modalService.open(content, { size: 'lg', centered: true });
    this.authServices.clearFormAttachments();
  }

  private autoSelectSingleCategory(): void {
    if (this.categories && this.categories.length === 1) {
      this.uploadData.category = this.categories[0].key;
      this.onCategoryChange();
    }
  }

  onCategoryChange() {
    this.uploadData.docType = '';
    this.docTypeError = '';
    if (this.uploadData.category) {
    }

    this.cdr.detectChanges();
  }

  deleteSupportingDocumentRow(index: number) {
    if (typeof index === 'object' && index !== null) {
      const row: any = index;
      if (row) {
        const foundIndex = (this.filteredsupportingWitnessesData as any[]).findIndex((r: any) => r.file === row.file && r.strFileName === row.strFileName);
        this.supportingDocDeleteIndex = foundIndex !== -1 ? foundIndex : null;
      } else {
        this.supportingDocDeleteIndex = null;
      }
    } else {
      this.supportingDocDeleteIndex = index;
    }
    this.isSupportingDelete = true;
    this.showDeleteModal = true;
  }

  downloadSupportingDocument(row: any) {
    const url = row.strFileHash;
    const contentType = row.strDocumentType;
    if (url) {
      this.httpService.getDownload(url, contentType).subscribe({
        next: (blob: Blob) => {
          const downloadLink = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          downloadLink.href = objectUrl;
          downloadLink.download = row.strFileName || 'downloaded_file';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(objectUrl);
        }
      });
    } else {
      this.alertService.error('No file URL available for download.');
    }
  }
  closeUploadPopup() {
    this.uploadError = null;
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch { }
    this.authServices.clearFormAttachments();
    this.modalService.dismissAll();
    this.oneFileIsRequired = false;
    this.categoryError = '';
    this.docTypeError = '';
    this.filteredDocumentTypes = [];
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
  }

  updatewitness() {
    if (this.editWitnessIndex === undefined || this.editWitnessIndex < 0) return;
    const updated = this.editWitnessesForm.getRawValue();
    const updatedWitness = {
      strWitnessName: updated.witnesseName,
      strWitnessEmailAddress: updated.witnessesEmail,
      strWitnessPhoneNumber: updated.witnessesPhone,
      strStreetAddress: updated.witnessesAddress,
      strCity: updated.witnessesCity,
      strState: typeof updated.witnessesState === 'string' ? updated.witnessesState : '',
      strZip: updated.witnesseZip,
      strWitnessTextData: updated.witnessesTextData
    };
    if(this.typeParam !== 'add'){
      const payload = {
        ...updatedWitness,
        strWitnessTextData: this.stripHtml(updatedWitness.strWitnessTextData),
        complaintId: this.complaintId,
        intWitnessSupportingDocumentsId: this.selectedRow?.intWitnessSupportingDocumentsId,
        intUpdatedBy : this.user.id
      };
      this.complaintFormService.updateWitnessDocument(payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          console.log('Updated Witness Document:', response);
        },
        error: (error) => {
          console.error('Error updating witness document:', error);
        }
      });
    }
    this.filteredwitnessesData[this.editWitnessIndex] = { ...this.filteredwitnessesData[this.editWitnessIndex], ...updatedWitness };
    this.filteredwitnessesData = [...this.filteredwitnessesData];
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredwitnessesData
    });
    this.alertService.success(this.toastMessage['T0020']);
    if (this.cd && typeof this.cd.detectChanges === 'function') {
      this.cd.detectChanges();
    }
    this.closeModal();
  }

  validateWitnessEmail() {
    const emailControl = this.witnessesForm.get('witnessesEmail');
    const emailValue = emailControl?.value;
    if (!emailValue) {
      emailControl?.setErrors(null);
      return;
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,10}$/;
    if (!emailPattern.test(emailValue)) {
      emailControl?.setErrors({ 'M0015': true });
    } else {
      emailControl?.setErrors(null);
    }
  }

  validateWitnessPhone() {
    const phoneControl = this.witnessesForm.get('witnessesPhone');
    const phoneValue = phoneControl?.value;
    if (!phoneValue) {
      phoneControl?.setErrors(null);
      return;
    }
    const phonePattern = /^(\\+1[ ]?)?\\(\\d{3}\\)[ ]?\\d{3}[ ]\\d{4}$/;
    if (!phonePattern.test(phoneValue)) {
      phoneControl?.setErrors({ 'M0022': true });
    } else {
      phoneControl?.setErrors(null);
    }
  }

  validateWitnessStreet() {
    const streetControl = this.witnessesForm.get('witnessesAddress');
    const streetValue = streetControl?.value;
    if (!streetValue) {
      streetControl?.setErrors(null);
      return;
    }
    const streetPattern = /^[A-Za-z0-9][A-Za-z0-9\s.,\-'/#]*$/;
    const errors: any = {};
    if (!streetPattern.test(streetValue)) {
      errors['M0052'] = true;
    }
    if (streetValue.length < 3) {
      errors['minlength'] = true;
    }
    if (streetValue.length > 60) {
      errors['maxlength'] = true;
    }
    if (Object.keys(errors).length > 0) {
      streetControl?.setErrors(errors);
    } else {
      streetControl?.setErrors(null);
    }
  }
  onFileRejected(event: any) {
    if (event && event.type === 'size') {
      this.uploadError = this.errorMessage['M0128'];;
    } else if (event && event.type === 'type') {
      this.uploadError = this.errorMessage['M0129'];
    } else {
      this.uploadError = 'File upload error. Please select a valid file.';
    }
  }
  validateWitnessCity() {
    const cityControl = this.witnessesForm.get('witnessesCity');
    const cityValue = cityControl?.value;
    if (!cityValue) {
      cityControl?.setErrors(null);
      return;
    }
    const cityPattern = /^[A-Za-z\s'-]{2,60}$/;
    const errors: any = {};
    if (!cityPattern.test(cityValue)) {
      errors['pattern'] = true;
    }
    if (cityValue.length < 2) {
      errors['minlength'] = true;
    }
    if (cityValue.length > 60) {
      errors['maxlength'] = true;
    }
    if (Object.keys(errors).length > 0) {
      cityControl?.setErrors(errors);
    } else {
      cityControl?.setErrors(null);
    }
  }

  validateWitnessZip() {
    const zipControl = this.witnessesForm.get('witnessesZip');
    const zipValue = zipControl?.value;
    if (!zipValue) {
      zipControl?.setErrors(null);
      return;
    }
    // Only allow numbers, spaces, and hyphens, length 3-10
    const zipPattern = /^[A-Za-z0-9\s-]{3,10}$/;
    const errors: any = {};
    if (!zipPattern.test(zipValue)) {
      errors['pattern'] = true;
      errors['M0023'] = true;
    }
    if (zipValue.length < 3) {
      errors['minlength'] = true;
    }
    if (zipValue.length > 10) {
      errors['maxlength'] = true;
    }
    if (Object.keys(errors).length > 0) {
      zipControl?.setErrors(errors);
    } else {
      zipControl?.setErrors(null);
    }
  }

  closeToast() {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  onComplainantFirstNameInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    this.complaintForm.get('complainantFirstName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
  }
  onComplainantLastNameInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    this.complaintForm.get('complainantLastName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
  }

  educatorsFirstName(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    value = this.preventBackToBackChars(value);
    this.complaintForm.get('educatorsFirstName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
  }

  witnessesName(event: any, formType: 'main' | 'modal' = 'main') {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    value = this.preventBackToBackChars(value);
    if (formType === 'main') {
      this.witnessesForm.get('witnessesName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
    } else {
      this.editWitnessesForm.get('witnesseName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
    }
  }

  normalizeSpaces(value: string) {
    value = value.replace(/\s+/g, ' ');
    return value;
  }

  checkForTrailingSpace(event: any, controlName: string) {
    let value = event.target.value;
    this.complaintForm.get(controlName)?.setValue(value.trimEnd(), { emitEvent: false });
  }

  checkForSpecialCharAtEnd(controlName: string) {
    const fieldsToCheck = ['com'];
    if (!fieldsToCheck.includes(controlName)) return;

    const value = this.complaintForm.get(controlName)?.value;
    if (!value) return;

    let specialCharsPattern;
    if (controlName === 'complainantStreetAddress') {
      specialCharsPattern = /[.,\-'#\/]$/;
    } else {
      specialCharsPattern = /[.,\-&'()\/]$/;
    }

    // Check if the field ends with a special character
    const endsWithSpecialChar = specialCharsPattern.test(value);

    if (endsWithSpecialChar) {
      this.complaintForm.get(controlName)?.setErrors({
        ...this.complaintForm.get(controlName)?.errors,
        specialCharAtEnd: true
      });
    } else {
      // Remove the special character error if it exists
      const errors = this.complaintForm.get(controlName)?.errors;
      if (errors && errors['specialCharAtEnd']) {
        delete errors['specialCharAtEnd'];
        if (Object.keys(errors).length === 0) {
          this.complaintForm.get(controlName)?.setErrors(null);
        } else {
          this.complaintForm.get(controlName)?.setErrors(errors);
        }
      }
    }
  }

  // Clean up fields when user leaves them (blur event)
  onFieldBlur(event: any, controlName: string) {
    let value = event.target.value;
    value = value.trim();
    this.complaintForm.get(controlName)?.setValue(value, { emitEvent: false });

    // Check for special characters at the end of field
    this.checkForSpecialCharAtEnd(controlName);
  }

  preventBackToBackChars(value: string): string {
    value = value.replace(/^\s+/, '');
    value = value.replace(/\s{2,}/g, ' ');
    value = value.replace(/[.]{2,}/g, '.');
    value = value.replace(/[,]{2,}/g, ',');
    value = value.replace(/[-]{2,}/g, '-');
    value = value.replace(/[&]{2,}/g, '&');
    value = value.replace(/[']{2,}/g, "'");
    value = value.replace(/[\(]{2,}/g, '(');
    value = value.replace(/[\)]{2,}/g, ')');
    value = value.replace(/[\/]{2,}/g, '/');
    value = value.replace(/[#]{2,}/g, '#');
    value = value.replace(/([.,\-&'()\/#])\1+/g, '$1');
    while (/[.,\-&'()\/#][.,\-&'()\/#]/.test(value)) {
      value = value.replace(/([.,\-&'()\/#])([.,\-&'()\/#])/, '$1');
    }

    return value;
  }

  private formatPhoneNumberValue(input: string): string {
    if (!input) return '';
    input = input.replace(/[a-zA-Z]/g, '');
    // If starts with '+1', enforce '+1 (XXX) XXX XXXX' format
    if (input.startsWith('+1')) {
      if (input.length > 2 && input[2] !== ' ') {
        input = '+1 ' + input.slice(2);
      }
      let numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      // Strip repeated country code: e.g. user pasted 18XXXXXXXXX after field already had "+1 "
      if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.substring(1);
      }
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
    }
    // If starts with '(', enforce '(XXX) XXX XXXX' format
    if (input.startsWith('(')) {
      let digits = input.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    // If only digits, format as '(XXX) XXX XXXX'
    if (/^\d+$/.test(input)) {
      let digits = input.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    // Allow '+', '+1', '+1 ' as valid prefixes
    if (input === '+' || input === '+1' || input === '+1 ') {
      return input;
    }
    // For any other input, clear the field
    return '';
  }

  onStreetAddressInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z0-9\s\.\,\-\'\#\/]/g, '');
    value = value.substring(0, 60);
    value = this.preventBackToBackChars(value);
    this.complaintForm.get('complainantStreetAddress')?.setValue(value, { emitEvent: false });
    this.checkForSpecialCharAtEnd('complainantStreetAddress');
  }
  handleFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      this.oneFileIsRequired = true;
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      return;
    }
    const file = input.files[0];
    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'video/mp4',
      'audio/mpeg'
    ];
    const maxSize = 15 * 1024 * 1024;
    if (file.size > maxSize) {
      this.uploadError = this.errorMessage['M0128'];
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      if (this.fileInputRef && this.fileInputRef.nativeElement) {
        this.fileInputRef.nativeElement.value = '';
      }
      return;
    }
    if (!allowedTypes.includes(file.type)) {
      this.uploadError = this.errorMessage['M0129'];
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      // Clear the file input so user must reselect
      if (this.fileInputRef && this.fileInputRef.nativeElement) {
        this.fileInputRef.nativeElement.value = '';
      }
      return;
    }
    this.uploadData.file = file;
    this.uploadData.type = this.uploadData.type || file.type;
    this.uploadData.fileName = file.name;
    this.oneFileIsRequired = false;
    this.uploadError = null;
    this.saveEnable = false;
  }


  onSave(): void {
    this.loaderService.show();
    let data = {
      fileName: `${this.uploadData.fileName}`,
      contentType: this.uploadData.type || ''
    };
    this.complaintFormService.getUploadKey(data).subscribe((res: any) => {
      this.saveEnable = true;
      const url = res.data;
      const uploadDetails = this.uploadData.file;
      const type = this.uploadData.type;
      const fileURL = res.data;
      this.httpService.putUpload(url, uploadDetails, type).subscribe(() => {
        this.alertService.success(this.toastMessage['T0041']);
        this.uploadedFiles = [{
          strFileName: this.uploadData.file.name,
          strFileHash: fileURL,
          strDocumentType: this.uploadData.type,
          strStatus: 'Uploaded',
          strCdDocumentCategory: this.uploadData.category,
          dtDateUploaded: new Date(),
        }
        ];
        if(this.typeParam !== 'add'){
          const payload = {
            complaintId : this.complaintId,
            complaintFormId : this.complaintFormId,
            strCreatedBy: this.user.id,
            ...this.uploadedFiles[0]
          };
          this.complaintFormService.insertSupportingDocument(payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
            next: (response) => {
              this.uploadedFiles[0].intComplaintDocumentId = response.data.data[0].complaint_document_id;
            },
          });
        }
        this.filteredsupportingWitnessesData = [
          ...this.filteredsupportingWitnessesData,
          ...this.uploadedFiles
        ];
        this.supportingWitnessesDataGrid = DataGridVO.create({
          customHeaders: this.supportingWitnessesHeaders,
          visibleColumns: this.visibleSupportingColumns,
          data: this.filteredsupportingWitnessesData
        });
        this.closeUploadPopup();
        this.loaderService.hide();
      });
    });
  }
  clearState(element?: HTMLSelectElement, complaintForm?: boolean, editWitnessModal?: boolean) {
    if (complaintForm === true) {
      this.complaintForm.get('complainantState')?.setValue(null);
    } else if (editWitnessModal === true) {
      const ctrl = this.editWitnessesForm.get('witnessesState');
      ctrl?.setValue(null);
      ctrl?.markAsDirty();
      ctrl?.markAsTouched();
      this.editWitnessesForm.markAsDirty();
      this.editWitnessesForm.markAsTouched();
      setTimeout(() => {
        this.editWitnessesForm.updateValueAndValidity();
      }, 0);
    } else {
      this.witnessesForm.get('witnessesState')?.setValue(null);
    }
    if (element) {
      // focus the select after clearing so keyboard users can continue
      try {
        element.focus();
      } catch (e) {
        // ignore focus errors
      }
    }
  }
  linkToCase(row:any){
    if(this.typeParam !== 'add'){
      const paylaod = {
        complaintEmail : row.primary_email,
        licenseNumber : row.license_number,
        educatorName : row.educator_name,
        complaintId : this.complaintId,
        complaintCaseId: this.complaintFormId
      }
      this.complaintFormService.linkComplaintEducator(paylaod).pipe(take(1),takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          row.intComplaintCaseEducatorId = response.data.data[0].complaint_case_educator_id;
        },
      });
    }
    this.licenseEducatorData.push(row);
    this.licenseEducatorDataGridConfig = DataGridVO.create({
      customHeaders: this.licenseEducatorHeaders,
      visibleColumns: this.visibleLicenseEducatorColumns,
      data: this.licenseEducatorData
    });
    this.alertService.success(this.toastMessage['T0056']);
    this.closeLicenseModal();
  }
  deleteLicenseEducatorRow(index:number){
    this.licenseDeleteIndex = index;
    this.showDeleteModal = true;
  }
  assignList(){
    this.complaintFormService.getPersonByRole()
    .pipe(take(1),takeUntil(this.destroy$))
    .subscribe({
      next: (response) => {
        this.assignToList = response.data.data;
      }
    });
  }
  clearComplaintStatus(){
    this.complaintDecisionForm.get('complaintStatus')?.setValue(null);
  }
  clearAssignedTo(){
    this.complaintDecisionForm.get('complaintAssign')?.setValue(null);
  }
  clearComplaintArchivalStatus(){
    this.complaintArchivalForm.get('complaintArchivalStatus')?.setValue(null);
  }
  clearComplaintNotesSection(){
    this.complaintNotesForm.get('complaintNotesSection')?.setValue(null);
  }

  displayshowComplaintStatus() {
    const status = this.complaintDecisionForm.get('complaintStatus')?.value; 
     if(this.complaintSource == COMPLAINT_SOURCE.EXTERNAL){
      if(String(status) === String(this.complaintStatusMessages.find(s => s.value === 'Submitted')?.key) && 
      this.user.userroles[0].id === ROLE_ID.Chief_Compliance_Investigator){
      this.complaintDecisionForm.get('complaintStatus')?.setValue(null);
      this.showComplaintStatus = true;
      this.showAssignedToField = true;
      const allowedStatuses = ['Assigned', 'Invalid'];
      const filteredStatuses = this.complaintStatusMessages.filter(s => allowedStatuses.includes(s.value));
      this.complaintStatusMessages = filteredStatuses;
    }else if(String(status) === String(this.complaintStatusMessages.find(s => s.value === 'Submitted')?.key) && 
      this.user.userroles[0].id === ROLE_ID.Compliance_Investigator){
        this.showComplaintStatus = false;
      }else{
        this.showComplaintStatus = true;
        const notAllowedStatuses = ['Submitted', 'Invalid','Draft'];
        const filteredStatuses = this.complaintStatusMessages.filter(s => !notAllowedStatuses.includes(s.value));
        this.complaintStatusMessages = filteredStatuses;
        if(this.user.userroles[0].id === ROLE_ID.Chief_Compliance_Investigator){
          this.showAssignedToField = true;
        }      
      }
    }else if(status != null){
      this.showComplaintStatus = true;
      const notAllowedStatuses = ['Submitted', 'Invalid','Draft'];
      const filteredStatuses = this.complaintStatusMessages.filter(s => !notAllowedStatuses.includes(s.value));
      this.complaintStatusMessages = filteredStatuses;
      if(this.user.userroles[0].id === ROLE_ID.Chief_Compliance_Investigator){
        this.showAssignedToField = true;
      }
    }
    else{
      this.showComplaintStatus = false;
    }
  }

  disabledComplaintStatus(): boolean {
    const status = this.complaintDecisionForm.get('complaintStatus')?.value; 
    const statusObj = this.complaintStatusMessages.find(s => s.value === 'Assigned');
    if(this.complaintDecisionForm.invalid){
      return true;
    }
    if(status === statusObj?.key && this.licenseEducatorData.length == 0){
      return true;
    }else{
      return false;
    }
  }
  updateComplaintStatus(){
    const status = this.complaintDecisionForm.get('complaintStatus')?.value;
    const statusObj = this.complaintStatusMessages.find(s => s.value === 'Invalid');
    // const assignedStatusObj = this.complaintStatusMessages.find(s => s.value === 'Assigned');
     const options: NgbModalOptions = {
      backdrop: "static",
      centered: true,
      size: "md"
    };
    this.customModal = this.modalService.open(ModalComponent, options);
    const modalConfig: ModalConfig = {
      buttons: [
        { text: modalButtonTitles.cancel, code: 'N', btnOutline: true },
        { text: modalButtonTitles.confirm, code: 'Y', btnOutline: false }
      ],
      heading: modalHeading.confirmStatus,
      modalContent: '',
      hasTemplate: true,
      scrollable: true
    };
    if(status === statusObj?.key){
      modalConfig.modalContent = modalContent.statusInvalid;
      this.customModal.componentInstance.modalConfig = modalConfig;
    }else {
      modalConfig.modalContent = modalContent.statusAssigned(this.complaintStatusMessages.find(s => s.key === status)?.value || '');
      this.customModal.componentInstance.modalConfig = modalConfig;
    }
    this.customModal.componentInstance.emitData.subscribe((data: any) => {
      if(data.confirmed){
        const payload = {
          complaintId: this.complaintId,
          status: Number(this.complaintDecisionForm.get('complaintStatus')?.value),
          updated_by: this.user.id,
          assignee: this.complaintDecisionForm.get('complaintAssign')?.value ? Number(this.complaintDecisionForm.get('complaintAssign')?.value) : null,
         archivalStatus: this.complaintArchivalStatusMessages.find(s => s.key === this.complaintArchivalForm.get('complaintArchivalStatus')?.value)?.value,
         lockstatus:  this.complaintDecisionForm.get('complaintAssign')?.value ? 'LOCKED' : null 
        };
        this.complaintFormService.updateComplaintStatus(payload).subscribe({
          next: (response) => {
            if(response.data.success){
              this.updateTimeLineEntry(payload.complaintId, payload.status, (status === statusObj?.key) ? 2 : Number(this.complaintArchivalForm.get('complaintArchivalStatus')?.value));
              if(payload.assignee && this.complaintStatusMessages.find(s => s.key === status)?.value === 'Assigned'){
                this.notification();
              }
              if(this.complaintStatusMessages.find(s => s.key === status)?.value === 'Assigned'){
                this.httpService.get('/domain/lookup?requestType=COMPLAINT_STATUS').subscribe( {
                  next:(res:any)=>{
                    this.complaintStatusMessages = res.data;
                    const notAllowedStatuses = ['Submitted', 'Invalid','Draft'];
                    const filteredStatuses = this.complaintStatusMessages.filter(s => !notAllowedStatuses.includes(s.value));
                    this.complaintStatusMessages = filteredStatuses;
                  } 
                })
              }
            }
            this.customModal.close();
          },
          error: (error) => {
            console.error('Error updating complaint status:', error);
            this.customModal.close();
          }
        });
      }
    });
  }

   notification() {
    const notify = (userid: number, roleid: number) => {
      const payload = {
        priority: "High",
        message: `Complaint ${this.complaintId} has been assigned to you. It is now available in the Background queue for review.`,
        actionurl: "/pages/compliant-review",
        userid,
        roleid,
        customformid: 1,
        isnew: true,
        isactive: true
      };
      this.fingerprintService.FingerPrintPortalnotifiction(payload)
        .pipe(take(1), takeUntil(this.destroy$)).subscribe({
          next: (res: any) => {
            if (!res.data.success) {
              console.error(`Error while sending notification for user ${userid}, role ${roleid}`);
            }
          },
          error: err => {
            console.error(`Error sending notification for user ${userid}, role ${roleid}:`, err);
          }
        });
    };
    notify(Number(this.complaintDecisionForm.get('complaintAssign')?.value), null);
  }

  updateComplaintArchivalStatus(){
    const status = this.complaintArchivalForm.get('complaintArchivalStatus')?.value;
     const options: NgbModalOptions = {
      backdrop: "static",
      centered: true,
      size: "md"
    };

    this.customModal = this.modalService.open(ModalComponent, options);

    const modalConfig: ModalConfig = {
      buttons: [
        { text: modalButtonTitles.cancel, code: 'N', btnOutline: true },
        { text: modalButtonTitles.confirm, code: 'Y', btnOutline: false }
      ],
      heading: modalHeading.confirmStatus,
      modalContent: modalContent.archivalStatus(this.complaintArchivalStatusMessages.find(s => s.key === status)?.value || ''),
      hasTemplate: true,
      scrollable: true
    };
      this.customModal.componentInstance.modalConfig = modalConfig;
    this.customModal.componentInstance.emitData.subscribe((data: any) => {
      if(data.confirmed){
        const payload = {
          complaintId: this.complaintId,
          status: Number(this.complaintArchivalForm.get('complaintArchivalStatus')?.value),
          updated_by: this.user.id,
          complaint_status : this.complaintArchivalForm.get('complaintArchivalStatus')?.value == "2" ? Number(this.complaintStatusMessages.find(s => s.value === "Closed - Unfounded")?.key) : Number(this.complaintDecisionForm.get('complaintStatus')?.value)
        };
        this.complaintFormService.updateComplaintArchivalStatus(payload).subscribe({
          next: (response) => {
            this.complaintDecisionForm.get('complaintStatus')?.setValue(payload.complaint_status);
            if(response.data.success){
              this.updateTimeLineEntry(payload.complaintId, Number(this.complaintDecisionForm.get('complaintStatus')?.value), Number(this.complaintArchivalForm.get('complaintArchivalStatus')?.value));
            }
            this.customModal.close();
            if(this.complaintArchivalForm.get('complaintArchivalStatus')?.value == "2"){
              this.router.navigate(['/pages/queues/background']);
            }
          },
          error: (error) => {
            console.error('Error updating complaint status:', error);
            this.customModal.close();
          }
        });
      }
    });
  }
  updateTimeLineEntry(complaintId:string,statusKey: number, archivalStatus: number){
     const data = {
              complaintId : complaintId,
              statusKey : statusKey,
              archivalStatus : archivalStatus,
              createdBy : this.user.id
            }
           this.complaintFormService.insertTimeLineEntryComplaint(data).pipe(take(1), takeUntil(this.destroy$)).subscribe({
              next: (timelineResponse) => {
                console.log('Timeline entry inserted successfully:', timelineResponse);
              },
              error: (timelineError) => {
                console.error('Error inserting timeline entry:', timelineError);
              }
            });
  }
  resetNotesData(){
    this.complaintNotesForm.reset();
  }
  addNotesData(){
    const payload ={
       strComplaintId : this.complaintId,
       strNoteSection: this.complaintNotesForm.get('complaintNotesSection')?.value,
       strNoteText: this.complaintNotesForm.get('complaintNotesTextData')?.value,
       strCreatedBy: this.user.id,
    }
    this.complaintFormService.insertComplaintNotes(payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.complaintNotesForm.reset();
        this.complaintNotesData = response.data.data;
        this.setNotesData();
        this.alertService.success(this.toastMessage['T0005']);
      },
      error: (error) => {
        console.error('Error adding complaint notes:', error);
      }
    });
  }
  deleteNotesRow(row:any){
    this.deleteSelectedNotesRow = row;
    this.showDeleteNotesModal = true;
  }
  confirmDeleteNotesRow(row:any){
    const payload ={
      strComplaintId: this.complaintId,
      intUpdatedBy: this.user.id,
      intComplaintNotesId: row.complaint_notes_id
    };
    this.complaintFormService.deleteComplaintNotes(payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.complaintNotesData = response.data.data;
        this.setNotesData();
        this.alertService.success(this.toastMessage['T0040']);
      },
      error: (error) => {
        console.error('Error deleting complaint notes:', error);
      }
    });
  }
  setNotesData(){
     this.complaintNotesGridConfig = DataGridVO.create({
      customHeaders: this.complaintNotesHeaders,
      visibleColumns: this.visibleComplaintNotesColumns,
      data: this.complaintNotesData
    });
  }
  notesModal(row: any, isEdit: boolean, isView: boolean){
    this.selectedNotesRow = row;
    // Respect component-level viewOnly: force view mode and keep form disabled
    if (this.viewOnly) {
      this.isEditNotes = false;
      this.isViewNotes = true;
    } else {
      this.isEditNotes = isEdit;
      this.isViewNotes = isView;
    }
    this.editComplaintNotesForm.get('editNotesSection')?.setValue(row.note_section);
    this.editComplaintNotesForm.get('editNotesTextData')?.setValue(row.note_text);
    if (this.viewOnly || isView) {
      this.editComplaintNotesForm.disable();
    } else {
      this.editComplaintNotesForm.enable();
    }
    this.customModal = this.modalService.open(this.NotesModal, {
      backdrop: "static",
      centered: true,
      size: "xl",
      windowClass: 'custom-edit-record-modal'
    });
  }
  clearEditComplaintNotesSection(){
    this.editComplaintNotesForm.get('editNotesSection')?.setValue(null);
  }
  closeViewNotesModal(){
    this.customModal.close();
  }
  updateNotesData(){
    const payload ={
       strComplaintId: this.selectedNotesRow.complaint_id,
       strNoteText: this.editComplaintNotesForm.get('editNotesTextData')?.value,
       strNoteSection: this.editComplaintNotesForm.get('editNotesSection')?.value,
        intUpdatedBy: this.user.id,
        intComplaintNotesId: this.selectedNotesRow.complaint_notes_id

    };
    this.complaintFormService.updateComplaintNotes(payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.complaintNotesData = response.data.data;
        this.selectedNotesRow = null;
        this.setNotesData();
        this.customModal.close();
        this.alertService.success(this.toastMessage['T0020']);
      },
      error: (error) => {
        console.error('Error updating complaint notes:', error);
      }
    });
  }
  resetEditModal(){
     this.editComplaintNotesForm.get('editNotesSection')?.setValue(this.selectedNotesRow.note_section);
    this.editComplaintNotesForm.get('editNotesTextData')?.setValue(this.selectedNotesRow.note_text);
  }
 moveToNext() {
  if(this.typeParam !== 'add'){
    const payload = {
      strComplaintFirstName: this.complaintForm.get('complainantFirstName')?.value,
      strComplaintLastName: this.complaintForm.get('complainantLastName')?.value,
      strComplaintEmailAddress: this.complaintForm.get('complainantEmail')?.value,
      strComplaintMobileNumber: this.complaintForm.get('complainantPhoneNumber')?.value,
      strCdCity: this.complaintForm.get('complainantCity')?.value,
      strCdState: this.complaintForm.get('complainantState')?.value,
      strZipcode: this.complaintForm.get('complainantZip')?.value,
      strComplaintStreetAddress: this.complaintForm.get('complainantStreetAddress')?.value,
      strDescription: this.stripHtml(this.complaintForm.get('complaintTextData')?.value),
      intUpdatedBy: this.user.id,
      complaintId: this.complaintId,
      dtDateOfIncident: this.complaintForm.get('dateOfComplaint')?.value,
      strEducatorName: this.complaintForm.get('educatorsFirstName')?.value,
    }
    this.complaintFormService.updateComplaint(payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
      next: (response) => {
      },
      error: (error) => {
        this.alertService.error(this.toastMessage['T0017']);
        console.error('Error updating complaint:', error);
      }
    });
  }
    const tabList = JSON.parse(this.dataStore.getData('TABCONFIGLIST') || '[]');
    const currentTabIndex = tabList?.findIndex(tab => tab.id == 3730);
    const parentGridPageInfo = this.sessionStorage.getObj('backToGridPage')
      ? this.sessionStorage.getObj('backToGridPage')
      : this.sessionStorage.getObj('parentGridPage')
      ? this.sessionStorage.getObj('parentGridPage')
      : {};
    let nextTab = null;
    let islastTab = null;
    if (currentTabIndex !== -1 && currentTabIndex == tabList.length - 1) {
      islastTab = tabList[currentTabIndex + 1] ? false : true;
    }
    currentTabIndex !== -1 ? (nextTab = tabList[currentTabIndex + 1]) : null;
    let lastTabId = null;
    if (islastTab) {
      lastTabId = tabList[currentTabIndex]?.id;
    }
    const nextTabIndex = currentTabIndex + 1;
    this.alertService.success(this.toastMessage['T0020']);
    if (islastTab) {
      if (parentGridPageInfo.id) {
        this.router.navigate([`/pages/dynamic-search/search/${parentGridPageInfo?.id}`], { relativeTo: this.route });
      } else {
        this.router.navigate([`/pages/${parentGridPageInfo.name}`], { relativeTo: this.route });
      }
    } else if (nextTab && nextTab.id) {
      this.dataStore.setData('FORM_SUBMISSION_SUCCESS', { isRoute: true, nextPage: nextTabIndex, submissionId: null });
      return;
    } else {
      // this.location.back();
      return;
    }
  }
  onEducatorNameClick = (_name: string, event?: Event, rowData?: any): void => {
    if (event && typeof (event as any).preventDefault === 'function') {
      (event as Event).preventDefault();
    }
    const email = rowData?.primary_email;
    const licenseNumber = rowData?.license_number;
    if (email == null || email === '') {
      this.alertService.error('Educator record has no email address; cannot fetch person details.', true);
      return;
    }
    this.closeLicenseModal();
    // Call API to get person ID from email and license number
    this.complaintFormService.getPersonIdByLicenseNumberAndEmail(email, licenseNumber)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const personId = response?.data?.person_id;
          if (personId == null || personId === '') {
            this.alertService.error('Could not fetch person id for this educator.', true);
            return;
          }
          this.sessionStorage.setItem(LOOKUP_USER_RETURN_URL_KEY, this.router.url);
          this.router.navigate(['/pages/lookup-user', String(personId)]);
        },
        error: (err) => {
          console.error('Error fetching person ID:', err);
          this.alertService.error('Failed to fetch educator details. Please try again.', true);
        }
      });
  };
  ngOnDestroy(): void {
    if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }
  }

  private applyViewOnly(): void {
    if (!this.viewOnly) return;
    try {
      this.saveEnable = true;
      this.showColumnChooser = false;
      this.showSupportingColumnChooser = false;
      this.showLicenseEducatorColumnChooser = false;
      this.showSearchLicenseEducatorColumnChooser = false;
      // Disable all forms so controls render disabled and validation stops
      if (this.complaintForm && typeof this.complaintForm.disable === 'function') this.complaintForm.disable({ emitEvent: false });
      if (this.witnessesForm && typeof this.witnessesForm.disable === 'function') this.witnessesForm.disable({ emitEvent: false });
      if (this.editWitnessesForm && typeof this.editWitnessesForm.disable === 'function') this.editWitnessesForm.disable({ emitEvent: false });
      if (this.licenseEducatorForm && typeof this.licenseEducatorForm.disable === 'function') this.licenseEducatorForm.disable({ emitEvent: false });
      if (this.complaintDecisionForm && typeof this.complaintDecisionForm.disable === 'function') this.complaintDecisionForm.disable({ emitEvent: false });
      if (this.complaintArchivalForm && typeof this.complaintArchivalForm.disable === 'function') this.complaintArchivalForm.disable({ emitEvent: false });
      if (this.complaintNotesForm && typeof this.complaintNotesForm.disable === 'function') this.complaintNotesForm.disable({ emitEvent: false });
      if (this.editComplaintNotesForm && typeof this.editComplaintNotesForm.disable === 'function') this.editComplaintNotesForm.disable({ emitEvent: false });
    } catch (e) {
      // ignore
    }
  }
}